/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
 ==========================================================================================*/


export default {

    id: '',
    name: '',
    place_id: '',
    display_name: '',
    street: '',
    house_number: '',
    suffix: '',
    postal_code: '',
    city: '',
    country: '',
    timezone: '',
    telephone: '',
    longitude: '',
    latitude: '',
    max_bookings: '',
    extra_info_driver: '',
    company_comment: '',
    internal_comment: ''

}
